import { register } from "@shopify/theme-sections";
import { waitForElm } from "../helpers/util";

register("newsletter", {
  checkIfAlreadySubscribed() {
    const alreadySubscribed = window.location.href.includes(
      "?contact%5Btags%5D=newsletter&form_type=customer"
    );
    const errorEl = this.container.querySelector("[data-already-subscribed]");

    if (alreadySubscribed && errorEl) {
      errorEl.classList.remove("hidden");
    }
  },
  scrollToSection() {
    if (
      window.location.toString().includes("form_type") ||
      window.location.toString().includes("customer_posted")
    ) {
      if (document.getElementById("insta-feed")) {
        waitForElm(".insta-feed-item").then(() => {
          window.scroll({
            top: document.getElementById("newsletterSection").offsetTop - 130,
            behavior: "smooth",
          });
        });
      } else if (document.querySelectorAll(".product-recommendations")) {
        waitForElm(".recommend-item").then(() => {
          window.scroll({
            top: document.getElementById("newsletterSection").offsetTop - 130,
            behavior: "smooth",
          });
        });
      } else {
        window.scroll({
          top: document.getElementById("newsletterSection").offsetTop - 130,
          behavior: "smooth",
        });
      }
    }
  },

  onLoad: function (e) {
    this.scrollToSection();
    this.checkIfAlreadySubscribed();
  },
});
